import { getCanAdministerShares } from 'modules/shares/utils'
import { WorkspaceMinimalFragment } from 'gqlTypes'

const showWorkspaceSettings = (workspace: WorkspaceMinimalFragment): boolean =>
  workspace.userRole !== 'GUEST'

const canUserAdministerShares = (
  workspace: WorkspaceMinimalFragment
): boolean => getCanAdministerShares(workspace)

export { showWorkspaceSettings, canUserAdministerShares }
